import { BackendModel, BackendService } from '../core/backend.service';
import { Telefono } from '../security/user/telefono.model';
import { Email } from '../security/user/email.model';

import * as moment from 'moment';
import { ProductoAcuerdo } from './producto-acuerdo.model';
import { OperationalParametric } from '../cliente/operationalParametric.model';
import { Cliente } from '../cliente/cliente.model';
import { User } from '../security/user/user.model';
import { EmailAcuerdo } from './email-acuerdo.model';
import { CategoriaAcuerdo } from './categoria-acuerdo.model';

export class Acuerdo extends BackendModel {

  static path = '/acuerdos/';

  cliente: Cliente;
  usuario: User;
  numero: number;
  fecha: Date;
  estado: OperationalParametric;
  compraMaxima: number;
  observaciones: string;
  fechaDesde: string;
  fechaHasta: string;
  emails: EmailAcuerdo[];
  ejecutivoCuenta: User;
  sinLimiteCompra: Boolean;

  productos: ProductoAcuerdo[];
  categorias: CategoriaAcuerdo[];

}



// WEBPACK FOOTER //
// ./src/app/acuerdo/acuerdo.model.ts